import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

interface IProps {
  autoSaveStatus: boolean;
}

export const useToggleSavingStateMutation = () => {
  const { user: { customerId } } = useStore(state => state);
  return useMutation(
    'useToggleSavingStateMutation',
    async ({ autoSaveStatus }: IProps) => {
      await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/bucket/emergency/autoSave`,
        {
          autoSave: autoSaveStatus,
        },
      );
    },
  );
};
